import {Engine} from '@milestoneslabs/milestones-core-js';
import {mockAdapterSingleton} from "./MockAdapterSingleton";
import PropertySearchFilterAppResource
    from "@milestoneslabs/milestones-core-js/src/AppResources/PropertySearchFilterAppResource";

export default class PropertySearchFilterRepository extends PropertySearchFilterAppResource {
    constructor(data) {
        super(data);
        if (window.env.USE_AXIOS_MOCK_ADAPTER) {
            this.configureMockRoutes();
        }
    }

    configureMockRoutes() {
        mockAdapterSingleton
            .onGet(Engine.apiUrl() + "/properties/searches/filters/" + this.uuid)
            .reply(200, this.propertySearchFilterResponseData);
    }

    get propertySearchFilterResponseData() {
        return require('./propertySearchFilterInstances.json');
    }
}